var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"contextMenu",staticClass:"context-menu"},[(_vm.showMenu)?_c('div',{ref:"menu",staticClass:"menu",style:({ top: _vm.top, left: _vm.left }),attrs:{"tabindex":"-1"},on:{"blur":_vm.closeMenu,"click":_vm.closeMenu}},[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }